import { Box, IconButton, Skeleton, Theme, Typography } from '@mui/material'
import { BlueEditIcon, DeleteRedIcon, PersonIcon } from '../../assets/SvgIcons';
import { BankCardSkeleton } from '../banks/BankCard';
import { NomineeType } from '../../redux-store/types/api-types';

export default function NomineeCard(props: any): JSX.Element {
    const { isLoading = false, nominee, index } = props;
    const { nomineeName = "", nomineePercentage = "", nomineeRelationship = "", nomineeGuardianPan = "", idProofType="",idProofValue="" } = nominee || {} as unknown as NomineeType;
    return (
        <>
            {isLoading && <BankCardSkeleton />}
            {
                !isLoading &&
                (
                    <Box sx={(theme: Theme) => ({
                        p: {xs:"10px",sm:"18px"},
                        bgcolor: "background.paper",
                        boxShadow: `0px 4px 5px 0px ${theme.palette.common.black}0D`,
                        borderRadius: '10px',
                        border: `1px solid ${theme.palette.grey[100]}`,
                        height: '100%'
                    })}>
                        <Box>
                            <Box sx={(theme: Theme) => ({
                                paddingBottom: '10px', borderBottom: `1px solid ${theme.palette.grey[100]}`, borderWidth: '2px'
                            })}>
                                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <Typography variant='overline_600' sx={(theme: Theme) => ({
                                        color: theme.palette.primary[900]
                                    })}>
                                        {`Nominee ${index + 1} Details`}
                                    </Typography>
                                    <Box sx={{ display: 'flex', alignItems: 'center', columnGap: '5px' }}>
                                        {/* any icons or data here */}
                                    </Box>
                                </Box>
                                <Box sx={{ display: 'flex', gap: '15px', alignItems: 'center', mt: '20px' }}>
                                    <PersonIcon />
                                    <Box>
                                        <Typography color='text.primary' variant='body_500'>
                                            {nomineeName}
                                        </Typography>
                                        {/* <Typography color='text.secondary' variant='overline_400'>
                                            {email}
                                        </Typography> */}
                                    </Box>
                                </Box>
                            </Box>
                        </Box>
                        <Box sx={{ mt: '20px' }}>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', gap: 2 }}>
                                {/* Left Column */}
                                <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 2 }}>
                                    <Box>
                                        <Typography variant="overline_600" color="text.secondary">Relation</Typography>
                                        <Typography variant="overline_600" color="text.primary" sx={{ mt: '6px' }}>{nomineeRelationship || '-'}</Typography>
                                    </Box>
                                     <Box>
                                        <Typography variant="overline_600" color="text.secondary">ID Type</Typography>
                                        <Typography variant="overline_600" color="text.primary" sx={{ mt: '6px' }}>{idProofType || '-'}</Typography>
                                    </Box>
                                   
                                </Box>

                                {/* Right Column */}
                                <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 2, textAlign: 'right' }}>
                                     <Box>
                                        <Typography variant="overline_600" color="text.secondary">Nominee %</Typography>
                                        <Typography variant="overline_600" color="text.primary" sx={{ mt: '6px' }}>{nomineePercentage || '-'}</Typography>
                                    </Box>
                                    <Box>
                                        <Typography variant="overline_600" color="text.secondary">ID No.</Typography>
                                        <Typography variant="overline_600" color="text.primary" sx={{ mt: '6px' }}>{idProofValue || '-'}</Typography>
                                    </Box>
                                   
                                    {/* <Box>
                            <Typography variant="overline_600" color="text.secondary">Account Type</Typography>
                            <Typography variant="overline_600" color="text.primary" sx={{ mt: '6px' }}>{accountType || '-'}</Typography>
                        </Box> */}
                                </Box>
                            </Box>
                        </Box>
                    </Box>
                )
            }
        </>
    )
}